import { ReactNode, useContext, useState } from 'react';
import { ConfigurationContext, ConfigurationContextValue } from 'src/context/ConfigurationContext';

export function useConfigurationContext(): ConfigurationContextValue | null {
  return useContext(ConfigurationContext);
}

export function ConfigurationProvider({ children }: { children: ReactNode }) {
  const [isEditWorkflowMode, setIsEditWorkflowMode] = useState(false);
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);

  const value = {
    isEditWorkflowMode,
    setIsEditWorkflowMode,
    selectedWorkflow,
    setSelectedWorkflow,
  };

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>;
}
